import { EitherAsync } from "purify-ts";
import { GlobalLeaderBoardResponseDTO } from "../../service/dto/GlobalLeaderboardDTO";
import { leaderboardService } from "../../service/LeaderboardService";
import { GameRecord } from "../models/GameRecord";
import { GameType, RoomSource } from "../models/types";

interface IFetchLeaderboardUseCase {
  fetchLeaderboard(
    type: GameType,
    source: RoomSource
  ): EitherAsync<
    Error,
    { records: GameRecord[]; lastWeekWinner: GameRecord | null }
  >;
}

class FetchLeaderboardUseCase implements IFetchLeaderboardUseCase {
  fetchLeaderboard(
    type: GameType,
    source: RoomSource
  ): EitherAsync<
    Error,
    { records: GameRecord[]; lastWeekWinner: GameRecord | null }
  > {
    return EitherAsync<Error, GlobalLeaderBoardResponseDTO>(async () => {
      try {
        return leaderboardService.getLeaderboard(type, source);
      } catch {
        return Promise.reject(new Error("Failed to fetch data"));
      }
    }).map((dto) => {
      return {
        records: dto.leaderboard.map((item) => new GameRecord(item, type)),
        lastWeekWinner: dto.lastWinner
          ? new GameRecord(dto.lastWinner, type)
          : null,
      };
    });
  }
}

export const fetchLeaderboardUseCase: IFetchLeaderboardUseCase =
  new FetchLeaderboardUseCase();
